import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IPage } from '../models/shared.model';
import { BroadcastMessage, BroadcastMessageRequest } from '../models/broadcast-message.model';

@Injectable({
  providedIn: 'root',
})
export class BroadcastMessageService {
  constructor(private http: HttpClient) {}

  search(
    pageNumber: number,
    pageSize: number,
    sortBy?: string,
    sortDirection?: string,
    search?: string,
  ): Observable<IPage<BroadcastMessage>> {
    let paramsObject: { [k: string]: number | string } = {
      pageNumber,
      pageSize,
    };
    if (sortBy && sortDirection) {
      paramsObject['sortBy'] = sortBy;
      paramsObject['sortDirection'] = sortDirection.toUpperCase();
    }
    if (search) {
      paramsObject['search'] = search;
    }
    const params = new HttpParams({ fromObject: paramsObject });
    return this.http.get<IPage<BroadcastMessage>>(`broadcast-messages/search`, { params });
  }

  findById(id: number): Observable<BroadcastMessage> {
    return this.http.get<BroadcastMessage>(`broadcast-messages/${id}`);
  }

  create(data: BroadcastMessageRequest): Observable<BroadcastMessage> {
    return this.http.post<BroadcastMessage>('broadcast-messages', data);
  }

  cancel(id: number): Observable<BroadcastMessage> {
    return this.http.post<BroadcastMessage>(`broadcast-messages/${id}/cancel`, null);
  }
}
